export default __webpack_public_path__ + "static/i_2-6871e5e22717bae5dc226042e8806b23.png";